import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-subscription-cancel-confirmation',
  templateUrl: './subscription-cancel-confirmation.component.html',
  styleUrls: ['./subscription-cancel-confirmation.component.scss']
})
export class SubscriptionCancelConfirmationComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SubscriptionCancelConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  onNoClick(value): void {
    this.dialogRef.close(value);
  }

}
